import {
  PayerIcons,
  PayerMessages,
} from "src/app/utility/constants/page.constant";

export class PayerPage {
  msg: typeof PayerMessages = PayerMessages;
  icon: typeof PayerIcons = PayerIcons;
}
